import React, { forwardRef, HtmlHTMLAttributes, memo } from "react";
import classNames from "classnames";

import styles from "./ButtonGroup.styles.module.scss";

export type ButtonGroupPropsType = HtmlHTMLAttributes<HTMLDivElement>

export const ButtonGroup = memo(forwardRef<HTMLDivElement, ButtonGroupPropsType>((
  {
    children,
    className,
    ...props
  }, ref) => {

  return (
    <div
      {...props}
      ref={ref}
      className={classNames(
        className,
        styles.root,
      )}
    >
      {children}
    </div>
  );
}));
